import React from 'react'
import { Modal, Col, Row } from 'antd'

export default class extends React.Component {
  render() {
    const { visible } = this.props

    return (
      <Modal
        title="预订详情"
        visible={visible}
        onOk={this.props.handleReserveOk}
        onCancel={this.props.handleReserveCancel}
        width="600px"
      >
        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            id：
          </Col>
          <Col span={14}>135456</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            订单号：
          </Col>
          <Col span={14}>2023123016282164adf132152adf213</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            用户：
          </Col>
          <Col span={14}>小青</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            手机号：
          </Col>
          <Col span={14}>13188888888</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            支付时间：
          </Col>
          <Col span={14}>2023-04-06 06:32:13</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            支付金额：
          </Col>
          <Col span={14}>300.00</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            实收金额：
          </Col>
          <Col span={14}>300.00</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            状态:
          </Col>
          <Col span={14}>已完成</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            到店时间：
          </Col>
          <Col span={14}>2023-04-06 06:32:13</Col>
        </Row>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubReserve/components/reserveDetail.js